import { StrikeGoldWidgetTile } from '@/types/strikeGoldTypes';

import { StrikeGoldData } from './types';

export const getStrikeGoldProperties = ({
  strikeGoldData,
  strikeGoldTile,
  currency,
  locale,
}: {
  strikeGoldData: StrikeGoldData;
  strikeGoldTile: StrikeGoldWidgetTile;
  currency?: string;
  locale?: string;
}) => {
  if (
    !strikeGoldData ||
    !strikeGoldData.awardedEver ||
    !strikeGoldData.awardedToday
  )
    return;
  return {
    type: strikeGoldTile.type,
    images: {
      logo: strikeGoldTile.logo,
      background: strikeGoldTile.background,
    },
    currencyCode: currency,
    locale,
    values: [
      {
        name: strikeGoldTile.first_widget_field,
        value: strikeGoldData.awardedToday,
      },
      {
        name: strikeGoldTile.second_widget_field,
        value: strikeGoldData.awardedEver,
      },
    ],
    gradientClass: strikeGoldTile.gradientClass,
  };
};
